export class Ecall {
  public id: number;
  public customer: string;
  public customerShortName: string;
  public siteId: string;
  public locationShortName: string;
  public creationTime: string;
  public followup: Array<number>;
  public status: number;
  public remarks: string;
  public teamIds: Array<number>;
  public teamListModel: Array<any>;
  public contactPerson: string;
  public contactNumber: string;
  public contactEmail: string;
  public customerReport: string;
  public receivedTime: string;
  public arrivedTime: string;
  public completedTime: string;
  public location: string;
  public userArrayModels: Array<any>;

  constructor (
    id = 0,
    customer = '',
    customerShortName = '',
    siteId = '',
    locationShortName = '',
    creationTime = '',
    followup = [],
    status = 999,
    remarks = '',
    teamIds = [],
    teamListModel = [],
    contactPerson = '',
    contactNumber = '',
    contactEmail = '',
    customerReport = '',
    receivedTime = '',
    arrivedTime = '',
    completedTime = '',
    location = '',
    userArrayModels = []
  ) {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/ecall.ts